import { useMutation, useQueryClient } from "@tanstack/react-query";
import { privateAxios } from "../axiosInstances";
import { isAxiosError } from "axios";
import { BackofficePrestationType } from "@prisma/client";
import { BackofficePrestationDataType } from "@ac-expo/api-types";

export type UpdatePrestationPriceMutationData = {
  type: BackofficePrestationType;
  body: {
    name: string;
    priceTTC?: number | null;
    vatRate?: number | null;
    data?: BackofficePrestationDataType | null;
  };
};

const updatePrestationPrice = async (
  data: UpdatePrestationPriceMutationData
) => {
  try {
    const { data: response } = await privateAxios.patch(
      `/prestations/${data.type}`,
      data.body
    );
    return response;
  } catch (error) {
    if (isAxiosError(error)) error.message = error.response?.data.message;
    throw error;
  }
};

export const useUpdatePrestationPriceMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updatePrestationPrice,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["prestations"],
      });
    },
  });
};
